export enum DialogsHubEventTypes {
    HANDLE_ROUTED_DIALOG = "HandleRoutedDialog",
    HANDLE_MESSAGE = "HandleMessage",
    DETACH_DIALOG = "DetachDialog",
    PINNED_MESSAGES = "PinnedMessages"
}
export type DialogsHubEventCallback = (data: unknown) => Promise<void>
export type DialogsHubEvents = Record<DialogsHubEventTypes, DialogsHubEventCallback>
